import React from 'react'
import type { OverdueContextValue } from './OverdueContext.types'

export const OverdueContext = React.createContext<OverdueContextValue>({
  overdue: false,
  hasExplicitIcon: false,
  iconClaimedRef: { current: false },
})

export const CellOverdueIconContext = React.createContext(false)
